import React, {
  useEffect,
  useContext,
  lazy,
  Suspense,
  Fragment,
  useState,
} from 'react';

import Loader from '../components/Loader/Loader';
import { Button, Row, Col, Card, Space } from 'antd';
import { PoContext } from '../context/PurchaseOrder/PurchaseOrderContext';
import { Utils } from '../context/UtilsContext';
import PolistFilter from '../components/Filter/PolistFilter';

const PoList = lazy(() => import('../components/PurchaseOrder/PoList'));
const PurchaseOrderModal = lazy(() =>
  import('../components/PurchaseOrder/PurchaseOrderModal')
);

const PoDetailsView = ({ customers }) => {
  const [poModalConfig, setpoModalConfig] = useState({ view: false });
  const [refreshKey, setRefreshKey] = useState(0);
  
  const closeModal = () => setpoModalConfig({ view: false });
  
  const {
    purchaseOrder,
    getPO,
    cancelPo,
    userDetails,
    exportPoCsv,
    endorsePo,
  } = useContext(PoContext);
  const { setLoading } = useContext(Utils);
  
  //filter
  const defaultFilter = {
    search: '',
    sort: 'latest',
    customer: null,
    status: null,
    month: null,
    year: null,
  };
  const [filter, setFilter] = useState(defaultFilter);
  const [paginate, setPaginate] = useState({ page: 1, pageSize: 10 });
  
  const onFilter = () => getPO(setLoading, filter);
  const onResetFilter = () => {
    setFilter(defaultFilter);
    getPO(setLoading, defaultFilter);
  };
  //end filter

  const shouldFetchFromServer = ({ page, pageSize }) => {
    const totalData = page * pageSize;
    const currentDataLength = purchaseOrder.po.length;
    const dataTotalLength = purchaseOrder.poLength;
    let shouldReload = false;
    if (
      totalData > currentDataLength &&
      (dataTotalLength > totalData ||
        (dataTotalLength > totalData - pageSize &&
          dataTotalLength > currentDataLength))
    ) {
      shouldReload = true;
    }

    const shouldLoadAll =
      (totalData > dataTotalLength && dataTotalLength > totalData - pageSize) ||
      totalData === dataTotalLength
        ? `&start=${currentDataLength}&end=${dataTotalLength}`
        : ``;

    return {
      shouldReload,
      newPage: Math.floor(currentDataLength / 1000) + 1,
      shouldLoadAll,
    };
  };

  const onPageChange = (page, pageSize) => {
    const { shouldReload, newPage, shouldLoadAll } = shouldFetchFromServer({
      page,
      pageSize,
    });
    if (shouldReload) {
      getPO(setLoading, filter, newPage, shouldLoadAll);
    }
    setPaginate({ page, pageSize });
  };

  const onSizeChange = (page, pageSize) => {
    const { shouldReload, newPage, shouldLoadAll } = shouldFetchFromServer({
      page,
      pageSize,
    });
    if (shouldReload) {
      getPO(setLoading, filter, newPage, shouldLoadAll);
    }
    setPaginate({ page, pageSize });
  };

  const refreshContent = () => {
    getPO(setLoading, defaultFilter);
    setPaginate({ page: 1, pageSize: 10 });
  };

  useEffect(() => {
    getPO(setLoading, defaultFilter);
  }, [refreshKey]);

  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <PolistFilter
          filter={filter}
          setFilter={setFilter}
          onFilter={onFilter}
          onResetFilter={onResetFilter}
          customers={customers}
        />

        {/* add po modal */}
        {poModalConfig.view ? (
          <PurchaseOrderModal
            userType={userDetails.type}
            closeModal={closeModal}
            visible={poModalConfig.view}
            defaultValue={poModalConfig.defaultValue}
            onSuccess={refreshContent}
          />
        ) : null}
        
        <PoList
          userType={userDetails.type}
          setpoModalConfig={setpoModalConfig}
          cancelPo={cancelPo}
          customers={purchaseOrder.customers}
          poList={purchaseOrder.po}
          endorsePo={endorsePo}
          setLoading={setLoading}
          paginate={paginate}
          onPageChange={onPageChange}
          onSizeChange={onSizeChange}
          pageLength={purchaseOrder.poLength}
          onAddPO={() => setpoModalConfig({ view: true })}
          onRefresh={refreshContent}
          onExportCSV={() => exportPoCsv(setLoading, filter)}
        />
      </Suspense>
    </Fragment>
  );
};

export default PoDetailsView;